export class ChatMessageArticleAssociationModel {
  id?: number;
  title?: string;
  score?: number;
}

export type FileAttachment = {
  id: number;
  filename: string;
  url: string;
  is_image?: boolean;
};

export type QuizOption = {
  label: string;
  value: string;
};

export type QuizDepends = {
  field: string;
  value: string;
};

export type QuizField = {
  field: string;
  question: string;
  input_type: "select" | "text" | "number" | "date";
  options: QuizOption[] | null;
  depends_on?: QuizDepends | null;
  /** Pergunta opcional (AI-925): o front exibe "(opcional)" e permite pular. */
  optional?: boolean;
  /** Seleção múltipla (AI-925): permite escolher mais de uma opção (ex.: produtos). */
  multiple?: boolean;
  /** Permite "Outro" (AI-936): além das opções, o usuário pode digitar um valor livre. */
  allow_other?: boolean;
  /** AI-980: URL (relativa) de um recorte do contracheque destacando onde encontrar
   * esta informação. Quando presente, o front mostra o pop-up "Ver onde encontrar".
   * `null`/ausente -> sem pop-up. */
  reference_image_url?: string | null;
};

// Quiz estruturado (estilo AskUserQuestion) anexado a uma mensagem do agente em
// turnos de refinamento (AI-903). É um FORMULÁRIO em etapas: o usuário responde
// todas as perguntas no wizard e envia tudo de uma vez só ao final.
export type QuizModel = {
  fields: QuizField[];
};

export class ChatMessageModel {
  id?: number;
  idChatTutorial?: string;
  assistant_id?: number;
  content?: string;
  sender?: string;
  vote?: boolean;
  voted?: boolean;
  created_at?: string;
  is_remove?: boolean;
  isStreaming?: boolean;
  fullContent?: string;
  articles?: ChatMessageArticleAssociationModel[];
  step?: number;
  isReplay?: boolean;
  files?: FileAttachment[];
  quiz?: QuizModel | null;
}
